import axios from 'axios'
// import { store } from '@/module/store/store'
// import { app } from "@/main";

const api = process.env.VUE_APP_BASE_SERVER + 'api'

const axiosApi = axios.create({
  baseURL: api
})

/**
 *  http request 攔截器
 *  store取得token
 *  token 加入 headers.Authorization
 */
const setToken = async function (config) {
  // await store().dispatch('auth/LOGIN')
  // debugger
  // const token = store().state.auth.idToken

  (config.headers.Authorization = `Bearer 3|vq5ys29DRnhPOjMo6jwMcUM0A5DCoZ8mHGNKbV36`)
  return config
}

axiosApi.interceptors.request.use(
  setToken,
  error => {
    return Promise.error(error)
  })

/**
 *  http response 攔截器
 *  response error 返回 401 清除token訊息 並跳轉到登錄頁面
 *  回傳 錯誤訊息
 */

axiosApi.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // store().dispatch('auth/LOGOUT')
      }
    }
    return Promise.reject(error.response.data)
  })

axiosApi.defaults.withCredentials = false

export { axiosApi }
